import { combineReducers } from 'redux';

import userAuthenticationReducer from './reducer_user_authentication';
import memberReducer from './reducer_member';
import vendorReducer from './reducer_vendor';
import corporateReducer from './reducer_corporate';

const appReducer = combineReducers({
    userAuthentication:userAuthenticationReducer,
    member:memberReducer,
    vendor:vendorReducer,
    corporate:corporateReducer
})

const initialState = appReducer({}, {});

const rootReducer = (state, action) => {
  if (action.type === "LOG_OUT") {
    state = initialState
  }

  return appReducer(state, action);
}

export default rootReducer;